export default __webpack_public_path__ + "static/material_04-5161f8d85f80e5b533a663c808bec179.png";